(() => {
  if (window.PictoMiniSkuImages) return;
  const cache = new WeakMap();
  const safeImage = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, location.href);
      if (url.protocol !== 'https:' || url.username || url.password) return '';
      if (url.hostname !== 'cdn.shopify.com' && !(url.origin === location.origin && url.pathname.startsWith('/cdn/shop/'))) return '';
      return url.href;
    } catch (_) { return ''; }
  };
  const responsiveSet = (source) => {
    if (!source || /[\s,]/.test(source)) return '';
    const fragmentIndex = source.indexOf('#');
    const fragment = fragmentIndex < 0 ? '' : source.slice(fragmentIndex);
    const withoutFragment = fragmentIndex < 0 ? source : source.slice(0, fragmentIndex);
    const queryIndex = withoutFragment.indexOf('?');
    const base = queryIndex < 0 ? withoutFragment : withoutFragment.slice(0, queryIndex);
    const query = queryIndex < 0 ? '' : withoutFragment.slice(queryIndex + 1);
    const kept = query.split('&').filter((item) => {
      if (!item) return false;
      try { return decodeURIComponent(item.split('=')[0]).toLowerCase() !== 'width'; }
      catch (_) { return true; }
    });
    const prefix = base + '?' + (kept.length ? kept.join('&') + '&' : '') + 'width=';
    return [64, 96, 128, 160, 240, 336, 480].map((width) => prefix + width + fragment + ' ' + width + 'w').join(', ');
  };
  const update = (builder) => {
    if (!builder?.isConnected) return;
    const source = builder.querySelector('[data-pm-sku-index]');
    if (!source) return;
    let entry = cache.get(builder);
    if (!entry || entry.source !== source || entry.text !== source.textContent) {
      try { entry = {source, text:source.textContent, data:JSON.parse(source.textContent)}; cache.set(builder, entry); } catch (_) { return; }
    }
    const data = entry.data;
    const selectedCard = builder.querySelector('[data-combined-choice]:checked')?.closest('.pm-combined-choice');
    const activeKey = selectedCard?.querySelector('[data-pm-sku-image]')?.dataset.pmSkuKey || data.initialKey;
    const subjects = builder.querySelector('[data-option="1"]:checked')?.value || '';
    const selectedFinish = builder.querySelector('[data-option="2"]:checked')?.value || 'Gallery White';
    const stagedPainting = builder.querySelector('[data-addon-kind="painting"] [data-addon-toggle]')?.checked;
    const finish = stagedPainting ? 'Hand-Painted' : selectedFinish;
    builder.querySelectorAll('[data-pm-sku-image]').forEach((frame) => {
      let key = frame.hasAttribute('data-pm-sku-follow') ? activeKey : frame.dataset.pmSkuKey;
      if (key === 'single' || key === 'single_two') key = (frame.dataset.pmSkuSubjects || subjects) === 'Two People' ? 'single_two' : 'single';
      const selectedFinish = frame.dataset.pmSkuFinish || finish;
      const painted = selectedFinish === 'Hand-Painted';
      const url = safeImage(data.images[key]?.[painted ? 'painted' : 'white']);
      const image = frame.querySelector('img');
      if (!image) return;
      const srcset = responsiveSet(url);
      if (srcset) {
        if (image.getAttribute('sizes') !== 'auto, 160px') image.setAttribute('sizes', 'auto, 160px');
        if (image.getAttribute('srcset') !== srcset) image.setAttribute('srcset', srcset);
      } else {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      }
      if (url) { if (image.getAttribute('src') !== url) image.setAttribute('src', url); image.hidden = false; }
      else { image.hidden = true; image.removeAttribute('src'); }
      frame.dataset.pmSkuResolved = key + ':' + (painted ? 'painted' : 'white');
      const label = (frame.hasAttribute('data-pm-sku-follow') ? selectedCard?.querySelector('[data-pm-sku-image]')?.dataset.pmSkuAlt : '') || frame.dataset.pmSkuAlt || image.alt.split(' · ')[0];
      const resolvedAlt = data.alts?.[key]?.[painted ? 'painted' : 'white'];
      const alt = typeof resolvedAlt === 'string' && resolvedAlt ? resolvedAlt : label + ' · ' + (painted ? data.paintedLabel : data.whiteLabel);
      if (image.alt !== alt) image.alt = alt;
    });
  };
  const initialize = (root = document) => root.querySelectorAll('[data-v2-builder]').forEach(update);
  window.PictoMiniSkuImages = Object.freeze({update});
  document.addEventListener('pictomini:builder-updated', (event) => { const builder = event.target.closest('[data-v2-builder]'); queueMicrotask(() => update(builder)); });
  document.addEventListener('change', (event) => { const builder = event.target.closest?.('[data-v2-builder]'); if (builder) queueMicrotask(() => update(builder)); });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true}); else initialize();
})();

